import React from "react";
import { Row, Col, Container } from "react-bootstrap";
import "./FooterComponent.css";
import MailOutlineIcon from "@mui/icons-material/MailOutline";
import { Link } from "react-router-dom";

export const FooterComponent = () => {
  return (
    <footer className="footer-main py-4">
      {" "}
      {/* Semantic HTML tag */}
      <Container>
        <Row className="align-items-center justify-content-center">
          <Col lg={12}>
            {/* Main Content Row */}
            <Row className="py-3 mt-3">
              <Col lg={4} className="mb-4 mb-lg-0">
                <div className="head-content text-start">
                  <img
                    src={require("../Assets/Footer/image.png")}
                    className="footer-logo my-4"
                    alt="PiLog Group Logo"
                    loading="lazy"
                    width="180" // Added explicit dimensions
                    height="auto"
                  />
                  <h2 className="h4">
                    {" "}
                    {/* Better heading hierarchy */}
                    Are You Prepared to Collaborate with us?
                  </h2>
                </div>
                <div className="footer-mail py-3 d-flex align-items-center">
                  <MailOutlineIcon className="email-icon me-2" />
                  <a
                    href="mailto:promotions@piloggroup.org"
                    className=" text-decoration-none"
                  >
                    promotions@piloggroup.org
                  </a>
                </div>
              </Col>

              {/* Services Column */}
              <Col lg={3} className="mb-4 mb-lg-0">
                <div className="our-services-footer">
                  <h5 className="mb-3">Our Services</h5>
                  <ul className="list-unstyled-footer">
                    {" "}
                    {/* Semantic list */}
                    <li className="mb-2">
                      <Link
                        to="lean-data-governance"
                        className=" text-decoration-none"
                      >
                        Data Governance
                      </Link>
                    </li>
                    <li className="mb-2">
                      <Link
                        to="iDQM"
                        className=" text-decoration-none"
                      >
                        Data Quality
                      </Link>
                    </li>
                    <li className="mb-2">
                      <Link
                        to="ai-lens"
                        className=" text-decoration-none"
                      >
                        AI Lens
                      </Link>
                    </li>
                    <li className="mb-2">
                      <Link
                        to="strategic-advisory"
                        className=" text-decoration-none"
                      >
                        Strategic Advisory
                      </Link>
                    </li>
                    <li className="mb-2">
                      <Link
                        to="value-proposition"
                        className=" text-decoration-none"
                      >
                        Value Propositions
                      </Link>
                    </li>
                  </ul>
                </div>
              </Col>

              {/* Quick Links Column */}
              <Col lg={3} className="mb-4 mb-lg-0">
                <div className="our-services-footer">
                  <h5 className="mb-3">Quick Links</h5>
                  <ul className="list-unstyled-footer">
                    <li className="mb-2">
                      <Link
                        to="Contact"
                        className=" text-decoration-none"
                      >
                        Contact Us
                      </Link>
                    </li>
                    <li className="mb-2">
                      <Link
                        to="privacy-policy"
                        className=" text-decoration-none"
                      >
                        Privacy Policy
                      </Link>
                    </li>
                    {/* Additional suggested links commented out */}
                    <li className="mb-2">
                      <Link
                        to="/about-us"
                        className=" text-decoration-none"
                      >
                        About Us
                      </Link>
                    </li>
                  </ul>
                </div>
              </Col>

              {/* Gartner Badge Column */}
              <Col
                lg={2}
                md={4}
                sm={6}
                className="mt-2 mt-lg-0 text-center text-lg-start"
              >
                <img
                  src={require("../Assets/Footer/customer-first-gartner-blue.png")}
                  alt="Gartner Peer Insights Customer First Badge"
                  className="img-fluid"
                  loading="lazy"
                  style={{ maxWidth: "150px" }}
                />
              </Col>
            </Row>

            {/* Bottom Row - Social and Copyright */}
            <Row className="mt-4 pt-3 border-top border-white">
              <Col md={6} className="mb-3 mb-md-0">
                <div className="social-media-icons">
                  <p className="mb-2">Follow us on</p>
                  <div className="footer-social-icons d-flex gap-3">
                    {/* Social icons with proper aria-labels */}
                    <a
                      href="https://www.facebook.com/piloggroup"
                      aria-label="Facebook"
                      className="social-icon"
                    >
                      <img
                        src={require("../Assets/Footer/SOCIAL-MEDIA_ICONS-07.png")}
                        alt="Facebook"
                        loading="lazy"
                        width="32"
                        height="32"
                      />
                    </a>
                    <a
                      href="https://x.com/PiLog_group"
                      aria-label="Twitter"
                      className="social-icon"
                    >
                      <img
                        src={require("../Assets/Footer/SOCIAL-MEDIA_ICONS-10.png")}
                        alt="Twitter"
                        loading="lazy"
                        width="32"
                        height="32"
                      />
                    </a>
                    <a
                      href="https://www.youtube.com/channel/UCEOznx22QvZvTbkeJ-lj7GQ"
                      aria-label="YouTube"
                      className="social-icon"
                    >
                      <img
                        src={require("../Assets/Footer/SOCIAL-MEDIA_ICONS-09.png")}
                        alt="YouTube"
                        loading="lazy"
                        width="32"
                        height="32"
                      />
                    </a>
                    <a
                      href="https://www.instagram.com/piloggroup/"
                      aria-label="Instagram"
                      className="social-icon"
                    >
                      <img
                        src={require("../Assets/Footer/SOCIAL-MEDIA_ICONS-08.png")}
                        alt="Instagram"
                        loading="lazy"
                        width="32"
                        height="32"
                      />
                    </a>
                    <a
                      href="https://www.linkedin.com/company/piloggroup/"
                      aria-label="LinkedIn"
                      className="social-icon"
                    >
                      <img
                        src={require("../Assets/Footer/SOCIAL-MEDIA_ICONS-06.png")}
                        alt="LinkedIn"
                        loading="lazy"
                        width="32"
                        height="32"
                      />
                    </a>
                  </div>
                </div>
              </Col>
              <Col
                md={6}
                className="d-flex align-items-center justify-content-md-end"
              >
                <p className="mb-0">© 2024 PiLog Group. All Rights Reserved</p>
              </Col>
            </Row>
          </Col>
        </Row>
      </Container>
    </footer>
  );
};
